import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Radio } from 'antd';
import { useScoringCategories } from '@/features/constructorScoringCategory/hooks';
import { ConstructorApi } from '@/features/constructor/api';
import { queryClient } from '@/app/QueryClientProvider';
import { adminLocalizationApi, adminLocalizationKeys } from '@/api';
import { useParams } from 'react-router';
import { usePopups } from '@/hooks';

export const ScoringRiskCategoryForAnswer = ({ answer, closeModal }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, isLoading } = useScoringCategories();
  const { showErrorToast, showSuccessToast } = usePopups();
  const [currentCategory, setCurrentCategory] = useState(answer.categoryScoringId);

  if (isLoading) return <div>{t('Loading')}...</div>;

  const onAdd = async () => {
    try {
      const result = await ConstructorApi.updateAnswerScoringCategory({
        availableAnswerId: answer.id,
        categoryScoringId: currentCategory
      });
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getQuestionnaireSections],
          queryFn: () =>
            adminLocalizationApi.getQuestionnaireSections({
              questionSectionTypeId: id
            })
        });
        showSuccessToast('Updated');
      }
      closeModal();
    } catch (e) {
      showErrorToast(e, true);
      console.log(e);
    }
  };

  return (
    <div>
      <Box>
        <CategoryBox>
          <Radio.Group
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8
            }}
            name='riskCategories'
            value={currentCategory}
            options={data.map((category) => ({
              value: category.id,
              label: `${category.name} (${category.minPoints}-${category.maxPoints} points)`
            }))}
            onChange={(e) => setCurrentCategory(e.target.value)}
          />
        </CategoryBox>
        <Button
          onClick={() => setCurrentCategory(null)}
          type='primary'
          style={{ marginTop: '20px' }}
          disabled={!currentCategory}
        >
          {t('Unset category')}
        </Button>
      </Box>
      <BtnBox>
        <Button
          onClick={onAdd}
          type='primary'
          style={{ marginTop: '30px' }}
          disabled={currentCategory === answer.categoryScoringId}
        >
          {t('Update category')}
        </Button>
      </BtnBox>
    </div>
  );
};

const Box = styled.div`
  height: 600px;
  overflow-y: scroll;
`;

const CategoryBox = styled.div`
  padding-left: 20px;
`;

const BtnBox = styled.div`
  text-align: right;
`;
